import PropTypes from 'prop-types';
import NavBarTabletDropdownElement from './NavBarTabletDropdownElement';
import NavBarTabletPhoneAccess from './NavBarTabletPhoneAccess';
import Flux from '../../flux/Flux';
import { generateKey } from '../../utils/CommonUtils';
import { Component } from 'react';

class NavBarTabletDropdown extends Component {
	constructor(props) {
		super(props);

		this.onPhoneAccessChange = this.onPhoneAccessChange.bind(this);
	}

	componentDidMount() {
		Flux.Browser.addShowPhoneAccessChangeListener(this.onPhoneAccessChange);
	}

	componentWillUnmount() {
		Flux.Browser.removeShowPhoneAccessChangeListener(this.onPhoneAccessChange);
	}

	onPhoneAccessChange() {
		this.forceUpdate();
	}

	render() {
		const navBarElements = this.props.navLinks.map((e, idx) => {
			const caption = e ? e.caption : '';
			return (
				<NavBarTabletDropdownElement
					key={generateKey(caption, idx)}
					name={e.caption}
					link={e.link}
					subElements={e.subNavigation}
					isNew={e.isNew}
					hasSale={e.hasSale}
				/>
			);
		});

		if (Flux.Browser.getShowPhoneAccess()) {
			const key = generateKey(this.props.voiceCallLabel, navBarElements.length);
			const voiceCall = <NavBarTabletPhoneAccess key={key} name={this.props.voiceCallLabel} />;
			navBarElements.push(voiceCall);
		}

		return <ul className="navbar-tablet__dropdown-menu">{navBarElements}</ul>;
	}
}

NavBarTabletDropdown.propTypes = {
	navLinks: PropTypes.arrayOf(
		PropTypes.shape({
			caption: PropTypes.string,
			link: PropTypes.string,
			isNew: PropTypes.bool,
			hasSale: PropTypes.bool,
			subNavigation: PropTypes.array,
		}),
	),
	voiceCallLabel: PropTypes.string,
};

NavBarTabletDropdown.defaultProps = {
	navLinks: [],
};

export default NavBarTabletDropdown;
